import list from './list';
import create from './create';
import edit from './edit';
import { isSuperAdmin } from '../../utils';

export default (permissions) => {
  const isVisible = isSuperAdmin(permissions);

  return {
    name: 'location',
    list: isVisible ? list : null,
    edit: isVisible ? edit : null,
    create: isVisible ? create : null,
    icon: 'map',
    options: {
      menuIndex: 4,
      isHidden: !isVisible,
    },
  };
};
